import { OnInit, Input, Output, EventEmitter, Component } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';

@Component({
  selector: 'iw-button-download',
  template: '<button *ngIf="associate" class="btn btn-success btn-xs" (click)="onClick()">' +
            '<i class="fa fa-plus" aria-hidden="true"></i> Asociar</button>' +
            '<button *ngIf="!associate" class="btn btn-danger btn-xs m-1" (click)="onClick(\'eliminar\')">' +
            '<i class="fa fa-trash" aria-hidden="true"></i> Desasociar</button>' +
            '<button *ngIf="!associate && funtions" class="btn btn-warning btn-xs m-1" ' +
            '(click)="onClick(\'funciones\')"> <i class="fa fa-sliders" aria-hidden="true"></i> Funciones</button>',

  styles: [`
        .btn-xs {
          font: 400 10.3333px Arial !important;
        }
    `]
})
export class ButtonsAssociateDocumentComponent implements ViewCell, OnInit {
  // entrada del valor del boton
  @Input() value: number;
  // entrada de la fila a la cual se le dio click
  @Input() rowData: any;
  // contiene el valor de entrada
  renderValue: number;
  // define cuando se realiza la accion de asociar
  associate = true;
  // Define si se activa el boton de funciones
  funtions = true;
  // salida del evento del click
  @Output() save: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    this.renderValue = this.value;

    if (this.rowData['associate'] === 'No') {
      this.associate = true;
    } else {
      this.associate = false;
    }

    if (this.rowData['funtions'] && this.rowData['funtions'] === 'NoFuntions') {
      this.funtions = false;
    }
  }
  /**
   * Emite el evento retornando la data de la fila selecionada al dar click en el boton
   *
   * @param {string} [action='asociar']
   * @memberof ButtonsAssociateDocumentComponent
   */
  onClick(action: string = 'asociar') {
    this.save.emit({action: action, row: this.rowData, value: this.value});
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/component-table/buttons-associate-document.component.ts